"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorHandlerWithGlobal = exports.errorHandler = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _GlobalMessage = require("../types/GlobalMessage.types");

var _handleError = require("../../ApiService/handleError");

var _globalMessage = require("../store/globalMessage.actions");

var _handlers = require("../../ApiService/handleError/handlers");

var hasExcludedStatus = function hasExcludedStatus(status) {
  return status >= 500 || status === 403 || status === 401;
};

var handleLegacyValidationErrorsAsText = (0, _handlers.createErrorHandler)(_handleError.HandlerTypes.Validation, function (response) {
  return ['status' in response && !hasExcludedStatus(response.status) && 'errors' in response, Object.values(response.errors || {}).filter(function (error) {
    return error;
  }).map(function (error) {
    return Array.isArray(error) ? error.join('. ') : error;
  }).join('\n'), response];
});
var handleLegacyUnknownError = (0, _handlers.createErrorHandler)(_handleError.HandlerTypes.AnyError, function (response) {
  return ['status' in response && !hasExcludedStatus(response.status) && (!('errors' in response) || Array.isArray(response.errors)), response];
});
var legacyHandleError = (0, _handleError.createConfiguredComposeHandlers)({
  defaultHandlers: [_handleError.handlers.handleJsError((0, _globalMessage.showGlobalMessage)({
    text: _handleError.MESSAGES.CLIENT_SIDE_ERR,
    type: _GlobalMessage.MessageType.Error
  })), _handleError.handlers.handleForbidden((0, _globalMessage.showGlobalMessage)({
    type: _GlobalMessage.MessageType.Error,
    text: _handleError.MESSAGES.PERMISSION_DENIED_ERR
  })), _handleError.handlers.handleInternalError((0, _globalMessage.showGlobalMessage)({
    text: _handleError.MESSAGES.INTERNAL_SERVER_ERR,
    type: _GlobalMessage.MessageType.Error
  }))]
});

var errorHandler = function errorHandler() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$callbacks = _ref.callbacks,
      callbacks = _ref$callbacks === void 0 ? [] : _ref$callbacks,
      _ref$showErrorsAsGlob = _ref.showErrorsAsGlobal,
      showErrorsAsGlobal = _ref$showErrorsAsGlob === void 0 ? false : _ref$showErrorsAsGlob,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? _GlobalMessage.MessageVariant.Snackbar : _ref$variant,
      redirect = _ref.redirect;

  return legacyHandleError(handleLegacyValidationErrorsAsText(function (text, response) {
    return showErrorsAsGlobal && text ? (0, _globalMessage.showGlobalMessage)({
      text: text,
      type: _GlobalMessage.MessageType.Error,
      variant: variant,
      errorDetails: variant === 'dialog' ? JSON.stringify(response.errors, undefined, 2) : undefined
    }) : undefined;
  }), handleLegacyUnknownError(function (response) {
    return ('message' in response || message) && (!showErrorsAsGlobal || !response.errors) ? (0, _globalMessage.showGlobalMessage)({
      text: response.message || message,
      type: _GlobalMessage.MessageType.Error
    }) : undefined;
  }), handleLegacyUnknownError(function (response) {
    return redirect ? redirect(response) : undefined;
  }), _handleError.handlers.handleLegacyAnyError.apply(_handleError.handlers, (0, _toConsumableArray2["default"])(Array.isArray(callbacks) ? callbacks : [callbacks])));
};

exports.errorHandler = errorHandler;

var errorHandlerWithGlobal = function errorHandlerWithGlobal() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$callbacks = _ref2.callbacks,
      callbacks = _ref2$callbacks === void 0 ? [] : _ref2$callbacks,
      _ref2$showErrorsAsGlo = _ref2.showErrorsAsGlobal,
      showErrorsAsGlobal = _ref2$showErrorsAsGlo === void 0 ? false : _ref2$showErrorsAsGlo,
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? '' : _ref2$message,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? _GlobalMessage.MessageVariant.Snackbar : _ref2$variant,
      redirect = _ref2.redirect;

  return legacyHandleError(handleLegacyValidationErrorsAsText(function (text, response) {
    var responseMessage = !!response.errors && response.errors.global || response.message;
    var fallbackMessage = showErrorsAsGlobal && !responseMessage ? text : responseMessage;
    return showErrorsAsGlobal || responseMessage ? (0, _globalMessage.showGlobalMessage)({
      text: !fallbackMessage && Array.isArray(response.errors) ? response.errors[0] : fallbackMessage,
      type: _GlobalMessage.MessageType.Error,
      variant: variant,
      errorDetails: variant === 'dialog' ? JSON.stringify(response.errors, undefined, 2) : undefined
    }) : undefined;
  }), handleLegacyUnknownError(function (response) {
    return ('message' in response || message) && (!showErrorsAsGlobal || !response.errors) ? (0, _globalMessage.showGlobalMessage)({
      text: response.message || response[0] || message,
      type: _GlobalMessage.MessageType.Error
    }) : undefined;
  }), handleLegacyUnknownError(function (response) {
    return redirect ? redirect(response) : undefined;
  }), _handleError.handlers.handleLegacyAnyError.apply(_handleError.handlers, (0, _toConsumableArray2["default"])(Array.isArray(callbacks) ? callbacks : [callbacks])));
};

exports.errorHandlerWithGlobal = errorHandlerWithGlobal;